module.exports = __webpack_public_path__ + "static/media/Cloudy.efcae05d.gif";